import { FormVmItemConfigType } from '../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../infrastructure/utils/form-config.utils';
import { trimSpacesLeft } from '../../../../../../modules/formatters';
import { plainText } from '../../../../../../modules/validators';

export enum EventAttributeAddValueFieldKey {
    LABEL = 'label',
    STATUS = 'status',
    EXTERNAL_ID = 'externalId'
}

export const FORM_CONFIG = {
    [EventAttributeAddValueFieldKey.LABEL]: {
        labelDescriptor: { id: 'oe.eventAttributes.addValue.label', defaultMessage: 'Label', description: 'Label for attribute value name' },
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [EventAttributeAddValueFieldKey.STATUS]: {
        defaultValue: true
    },
    [EventAttributeAddValueFieldKey.EXTERNAL_ID]: {
        labelDescriptor: { id: 'oe.eventAttributes.addValue.externalId', defaultMessage: 'External ID', description: 'Label for external identifier' },
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    }
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
